import { render } from "./B2bPageCierresContables.vue?vue&type=template&id=cc702a5a&scoped=true&lang=pug"
import script from "./B2bPageCierresContables.vue?vue&type=script&lang=js"
export * from "./B2bPageCierresContables.vue?vue&type=script&lang=js"

import "./B2bPageCierresContables.vue?vue&type=style&index=0&id=cc702a5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc702a5a"]])

export default __exports__